(function () {
  function initBundle(root) {
    var handle = root.getAttribute('data-product-handle');
    var addBtn = root.querySelector('[data-fh-bundle-add]');
    var radios = root.querySelectorAll('.fh-bundle__radio');

    function getSelectedTier() {
      var checked = root.querySelector('.fh-bundle__radio:checked');
      return checked ? checked.closest('.fh-bundle__tier') : null;
    }

    function tierIsComplete(tierEl) {
      if (!tierEl) return false;
      var selects = tierEl.querySelectorAll('.fh-bundle__select');
      for (var i = 0; i < selects.length; i++) {
        if (!selects[i].value) return false;
      }
      return true;
    }

    function refreshButtonState() {
      var tierEl = getSelectedTier();
      if (!tierEl) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select a bundle to continue';
        return;
      }
      if (!tierIsComplete(tierEl)) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select all options to continue';
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = 'Add Bundle to Cart';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', refreshButtonState);
    });
    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('fh-bundle__select')) refreshButtonState();
    });

    function getVariantIdForUnit(tierEl, unitIndex) {
      var selects = tierEl.querySelectorAll(
        '.fh-bundle__select[data-unit="' + unitIndex + '"]'
      );
      var selectedValues = [];
      selects.forEach(function (s) { selectedValues.push(s.value); });
      return { optionValues: selectedValues };
    }

    async function resolveVariantId(optionValues) {
      var res = await fetch('/products/' + handle + '.js');
      var productData = await res.json();
      var match = productData.variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return optionValues.every(function (val, idx) { return opts[idx] === val; });
      });
      return match ? match.id : null;
    }

    function tierLabel(tierEl) {
      var labelEl = tierEl.querySelector('.fh-bundle__tier-label');
      return labelEl ? labelEl.textContent.replace(/\s+/g, ' ').trim() : 'Bundle';
    }

    addBtn.addEventListener('click', async function () {
      var tierEl = getSelectedTier();
      if (!tierEl || !tierIsComplete(tierEl)) {
        refreshButtonState();
        return;
      }

      var qty = parseInt(tierEl.getAttribute('data-qty'), 10);
      var discount = tierEl.getAttribute('data-discount');
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;

      try {
        var items = [];
        var bundleId = 'bundle-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
        var bundleLabel = tierLabel(tierEl) + (discount ? ' \u2014 ' + discount + '% off' : '');

        if (qty === 1) {
          var res = await fetch('/products/' + handle + '.js');
          var productData = await res.json();
          items.push({ id: productData.variants[0].id, quantity: 1 });
        } else {
          for (var i = 1; i <= qty; i++) {
            var unit = getVariantIdForUnit(tierEl, i);
            var variantId = await resolveVariantId(unit.optionValues);
            if (variantId) {
              items.push({
                id: variantId,
                quantity: 1,
                properties: {
                  '_bundle_id': bundleId,
                  '_bundle_label': bundleLabel
                }
              });
            }
          }
        }

        if (items.length === 0) throw new Error('No variants resolved');

        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        if (!addRes.ok) {
          var errBody = await addRes.json();
          throw new Error(errBody.description || 'Could not add bundle to cart');
        }

        if (window.bumpCartCount) window.bumpCartCount();
        if (window.refreshCartDrawer) window.refreshCartDrawer();
        if (window.fhOpenCartDrawer) window.fhOpenCartDrawer();

        addBtn.textContent = 'Added!';
        setTimeout(function () { refreshButtonState(); }, 1600);
      } catch (e) {
        addBtn.textContent = 'Error \u2014 try again';
        setTimeout(function () { refreshButtonState(); }, 1800);
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });

    refreshButtonState();
  }

  document.querySelectorAll('[data-fh-bundle]').forEach(initBundle);
})();
